import { render } from "./card-rich.vue?vue&type=template&id=048ddf59&scoped=true&ts=true"
import script from "./card-rich.vue?vue&type=script&lang=ts"
export * from "./card-rich.vue?vue&type=script&lang=ts"

import "./card-rich.vue?vue&type=style&index=0&id=048ddf59&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ddf59"]])

export default __exports__